export enum SuggestionFormStep {
  CLIENT = 'CLIENT',
  LOCATION = 'LOCATION',
  DETAILS = 'DETAILS',
}
